// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abd36b29","658":"988fc634","668":"d46f39f4","803":"19e1a73e","857":"da1a9951"}[chunkId] + ".chunk.js";
};